import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { OTPInput } from '../OTPInput';
import { PInput } from './PInput';

interface PBaseFormField extends PInput {
  name: string;
  onSetOtpErrorMessage?: (value: string) => void;
  length?: number;
}

export const OTPFormField: React.FC<PBaseFormField> = ({
  name,
  onSetOtpErrorMessage,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <OTPInput
            {...props}
            value={field.value}
            onInputChange={e => {
              onSetOtpErrorMessage && onSetOtpErrorMessage('');
              field.onChange(e);
            }}
            isIconIndicatorVisible={false}
          />
        );
      }}
    />
  );
};
